export enum TableCellAlign {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum TableLayout {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
